import { queryOptions, useQuery } from "@tanstack/react-query";
import { api } from "../../http";
import type { Entity } from "@/lib/types/secure-llm";

interface EntitiesResponse {
  [key: string]: Array<Entity>; // A, B, C, etc. as keys with arrays of entities
}

async function getEntities() {
  return await api.governance.get<EntitiesResponse>("entities");
}

export const entitiesQueryOptions = queryOptions({
  queryKey: ["secure-llm", "entities"],
  async queryFn() {
    const res = await getEntities();
    const data = await res.json();

    // Flatten the alphabetical groups into a single array
    const flattened = Object.values(data).reduce((acc, group) => {
      return [...acc, ...group];
    }, [] as Array<Entity>);

    return flattened;
  },
});

export function useEntities() {
  return useQuery(entitiesQueryOptions);
}
